/* import __COLOCATED_TEMPLATE__ from './actions.hbs'; */
import { action, get } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import styles from './actions.module.scss';

export default class RequestConfirmationActions extends Component {
  styles = styles;
  @service currentPractice;
  @service router;
  @service session;
  @service iframe;

  @action
  afterCancel() {
    this.session.clearProspectiveClient();
  }

  @action
  returnToAppointment() {
    this.session.clearProspectiveClient();
    let route = get(this.currentPractice, 'useBookAppointmentLanguage')
      ? 'site.appointments.upcoming'
      : 'site.appointments.requested';
    this.router.transitionTo(route);
  }

  @action
  callCloseAction() {
    this.session.clearProspectiveClient();
    try {
      let currentURL = this.router.currentURL;
      if (currentURL.includes('widget')) {
        this.iframe.close();
        this.router.transitionTo('widget.index');
      } else {
        this.router.transitionTo('sign-in');
      }
    } catch (err) {
      // ignore if error on closing widget
    }
  }
}
